import { Outlet, useLocation } from "react-router";
import { useAuth } from "@/auth/use-auth";
import { redirectToLogin } from "@/auth/auth";

/**
 * Route guard for admin users.
 *
 * Renders child routes if the user is authenticated and has admin privileges.
 * Redirects to login if not authenticated.
 * Shows access denied message if authenticated but not admin.
 */
export function AdminRoute() {
  const { user, isLoading, isAdmin } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        Loading...
      </div>
    );
  }

  if (!user) {
    redirectToLogin(location.pathname);
    return null;
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <h1 className="text-2xl font-bold">Access Denied</h1>
        <p>You don't have permission to access this page.</p>
      </div>
    );
  }

  return <Outlet />;
}
